import { Langs } from '@/types/lang';
import { OnboardingCategory } from '@/types/onboarding';
import { requestQuery } from '@/services/request';
import { coreOnboardingRoute } from '@/modules/onboarding/domain/routes/onboardingRoutes';
import { mockCategories } from './getOnboardingJobCategories';

export const getOnboardingCategories = async (lang = Langs.Fr) => {
  try {
    const response = await requestQuery<{ categories: OnboardingCategory[] }>({
      url: coreOnboardingRoute,
      params: {
        lang,
      },
    });

    return response.categories;
  } catch (e) {
    return mockCategories;
  }
};
